import { render, staticRenderFns } from "./waterMarkSetting.vue?vue&type=template&id=ecaa6f3e&scoped=true"
import script from "./waterMarkSetting.vue?vue&type=script&lang=js"
export * from "./waterMarkSetting.vue?vue&type=script&lang=js"
import style0 from "./waterMarkSetting.vue?vue&type=style&index=0&id=ecaa6f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaa6f3e",
  null
  
)

export default component.exports